// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
// import required modules
import { Test1, Test2, Test3, Test5 } from "../Canva/Factories";
import dynamic from "next/dynamic";

const CustomScrollBarNoSSR = dynamic(
  () => import("@/components/Shares/CustomScrollBar"),
  { ssr: false },
);

const ShopTheLook2 = () => {
  return (
    <div className="container mx-auto flex flex-col items-center">
      <h2 className="text-4xl">Shop The Look</h2>
      <p className="text-lg mt-2 text-center">
        Shop inspirational rooms, styled by Priceworth Furniture
      </p>
      <div className="w-full pt-14">
        <CustomScrollBarNoSSR style={{ height: 340 }}>
          <div className="flex gap-5 w-max">
            <div className="min-w-[450px] h-[310px]">
              <Test1 />
            </div>
            <div className="min-w-[450px] h-[310px]">
              <Test2 />
            </div>
            <div className="min-w-[450px] h-[310px]">
              <Test3 />
            </div>
            <div className="min-w-[450px] h-[310px]">
              <Test5 />
            </div>
          </div>
        </CustomScrollBarNoSSR>
      </div>
    </div>
  );
};

export default ShopTheLook2;
